const translations: Record<string, string> = {
  "ak_dsp_failed_to_load_data": "Failed to load data",
  "ak_dsp_select_a_station_in_the_top_bar_to_see": "Select a station in the top bar to see the forecast.",
  "ak_dsp_trading_schedule": "Trading schedule",
  "ak_dsp_delivery_schedule_and_statuses": "delivery schedule and statuses",
  "ak_dsp_for_the_selected_day": "for the selected day",
  "ak_dsp_summary": "Summary",
  "ak_dsp_until_00": "until {{h}}:00",
  "ak_dsp_cumulative": "cumulative",
  "ak_dsp_generation_forecast": "Generation forecast",
  "ak_dsp_actual_generation": "Actual generation",
  "ak_dsp_forecast_performance": "Forecast performance",
  "ak_dsp_uploaded_to_mms": "Uploaded to MMS",
  "ak_dsp_kwh": "kWh",
  "ak_dsp_by_hours": "By hours",
  "ak_dsp_per_day": "Per day",
  "ak_dsp_24_h": "24 h",
};

export default translations;
